<template>
    <footer class="cert-footer pt-4 pb-0 footer">
        <div class="d-flex flex-column">
            <div class="row pt-3 px-3 px-md-0 mx-auto col-12 col-md-11 col-lg-10 col-xl-9">
                <div class="col-12 col-md-6">
                    <div class="cert-title">Contact Us</div>
                    <div class="cer-text">
                        <div class="d-flex flex-row">
                            <micon icon="email" class="material-icons-outlined"/>
                            <div>rwcsirt@ncsa.gov.rw</div>

                        </div>
                        <div class="d-flex flex-row">
                            <micon icon="support_agent" class="material-icons-outlined"/>
                            <div>9009 or 0781813310</div>
                        </div>
                        <div class="d-flex flex-row">
                            <micon icon="call" class="material-icons-outlined"/>
                            <div>+250 734 440 852 (International Calls / WhatsApp)</div>
                        </div>
                        <a href="https://twitter.com/Rw_csirt" class="d-flex flex-row" target="_blank">
                            <img src="../assets/img/icons/x-twitter.png" height="16" width="16" class="me-2 twitter-logo"/>
                            <div>@Rw_csirt</div>
                        </a>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-3 mt-xl-0">
                    <div class="cert-title">Subscribe to Alerts</div>
                    <div v-if="!done">
                        <div>Rw-CERT will send cybersecurity alerts and advisories directly to your email.</div>
                        <div class="d-flex flex-row mt-2">
                            <input ref="email" type="email" placeholder="Your email address" name="email"
                                   v-model="email"
                                   class="mt-0 cert-input"/>
                            <div class="cert-btn d-flex" @click="submit()">
                                <div class="my-auto">Sign Up</div>
                            </div>
                        </div>
                        <div id="email-validation-error" style="color: red">{{ validation.message }}</div>
                    </div>
                    <div v-else class="cert-done d-flex flex-row">
                        <div class="my-auto">Subscribed</div>
                        <micon icon="done"/>
                    </div>
                </div>
            </div>
            <div class="mt-4 py-2" style="border-top: 1px solid #00000020;font-size: 0.7rem;text-align: center">
                © {{ new Date().getFullYear() }}, Rwanda Computer Emergency Response Team
            </div>
        </div>
    </footer>
</template>

<style scoped>
.twitter-logo{
    opacity: 0.8;
    padding-top: 1px;
}
</style>
<script>
// import ArgonInput from "@/components/ArgonInput";
// import ArgonButton from "@/components/ArgonButton";
import api from "@/api";
import validators from "@/assets/helper/validators";

export default {
    name: "app-footer",
    components: {
        // ArgonInput,
        // ArgonButton,
    },
    data() {
        return {
            done: false,
            email: '',
            validation: {
                email: '',
                status: false,
                message: "",
            },
        };
    },
    methods: {
        submit() {
            let email = this.$refs["email"].value;
            if (validators.validateEmailAddress(email).status) {
                if (email == null || email.trim() === "")
                    return;

                api.post(`${process.env.VUE_APP_BASE_URL}subscription?email=${email}`)
                    .then((response) => {
                        response.data;
                        this.done = true;
                    })
                    .catch((error) => {
                        error;
                    });
            } else {
                this.validation.message = "Invalid email address";
            }
        }
    }
};

</script>
